import React from 'react'

export default function MerrickSpeedTwitter() {
    return (
        <>
            <a href="https://twitter.com/merrickspeed" target="_blank" rel="noopener noreferrer">@merrickspeed</a> on Twitter
        </>
    )
}
